const SCORE_SCALES = Object.freeze({
  curated: Object.freeze({ max: 10, label: 'Saved pairing' }),
  algorithmic_accord_overlap: Object.freeze({ max: 100, label: 'Note overlap' }),
})

function finiteNumber(value) {
  if (value === null || value === undefined || value === '') return null
  const number = Number(value)
  return Number.isFinite(number) ? number : null
}

function formatNumber(value) {
  return Number.isInteger(value) ? String(value) : value.toFixed(1)
}

// The database function owns both score calculations. Curated rows preserve
// their stored 0–10 score; algorithmic rows preserve its documented 0–100
// note-overlap score. We only convert each value to a percentage for the bar.
// No rank-to-score mapping or cross-scale rescaling happens in the client.
export function layeringScoreView(recommendation) {
  const scale = SCORE_SCALES[recommendation?.pairing_type]
  const raw = finiteNumber(recommendation?.compatibility_score)
  if (!scale || raw === null) return null

  const boundedForBar = Math.min(scale.max, Math.max(0, raw))
  return {
    raw,
    display: formatNumber(raw),
    max: scale.max,
    label: scale.label,
    progress: Math.round((boundedForBar / scale.max) * 100),
  }
}

export function visibleLayeringRecommendations(recommendations, limit = 3) {
  const safeLimit = Math.max(0, Math.trunc(Number(limit) || 0))
  return (Array.isArray(recommendations) ? recommendations : [])
    .map(recommendation => ({
      recommendation,
      score: layeringScoreView(recommendation),
    }))
    .filter(item => item.score)
    .slice(0, safeLimit)
}

export function pairingScoreView(pairing) {
  const direct = layeringScoreView(pairing)
  if (direct) return direct

  const savedScore = finiteNumber(pairing?.score)
  if (savedScore === null) return null
  return layeringScoreView({ pairing_type: 'curated', compatibility_score: savedScore })
}
